import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export default [
    {
        auth: authRoles.admin,
        routes: [{ path: '/hauling-contract-centerpoints', component: FuseLoadable({ loader: () => import('./HaulingContractCenterpointApp') }) }],
    },
];
